import { Alert, Modal, Space, Switch } from 'antd';
import JobTransferTable, { SelectedCustomerProperty } from './JobTransferTable';
import { useContext, useState } from 'react';
import VSpace from '../common/VSpace';
import { useBulkCopyJobMutation } from './jobsQueries';
import { ItemsContext } from '../Items/ItemsRoot';
import BulkCopyStatus from './BulkCopyStatus';
import { hasValue } from '../../helpers/nullable';
import { PricingTypes } from '../../common/constants';

export type Props = {
  visible: boolean,
  onClose: () => void,
  jobId: number,
}

const BulkCopyJobModal = ({ visible, onClose, jobId }: Props) => {
  const { jobData } = useContext(ItemsContext)
  const [selection, setSelection] = useState<SelectedCustomerProperty[]>([])
  const [copyNotes, setCopyNotes] = useState(false)
  const [batchId, setBatchId] = useState('')
  const bulkCopyJobMutation = useBulkCopyJobMutation(x => setBatchId(x))

  const hasRecurring = jobData.workareas.some(x => hasValue(x.masterWorkareaId))
  const hasFlatRate = jobData.workareas.some(x => x.pricingType === PricingTypes.FlatRate)

  const handleOk = () => {
    bulkCopyJobMutation.mutate({
      jobId: jobId,
      recipients: selection.map(x => ({ customerId: x.customerId, propertyId: x.propertyId })),
      copyInternalWorkareaNotes: copyNotes
    })
  }

  const handleClose = () => {
    setBatchId('')
    onClose()
  }

  return <Modal
    title="Copy Job"
    open={visible}
    onCancel={handleClose}
    onOk={handleOk}
    okButtonProps={{
      disabled: selection.length < 1 || bulkCopyJobMutation.isLoading,
      loading: bulkCopyJobMutation.isLoading,
      hidden: batchId !== ''
    }}
    okText="Copy"
    cancelText={batchId === '' ? "Cancel" : "Close"}
    width={1000}
    maskClosable={batchId === ''}
  >
    {batchId !== '' && <BulkCopyStatus batchId={batchId} selectedCustomerProperties={selection} />}
    {batchId === '' && <VSpace>
      {hasRecurring && <Alert
        type="info"
        showIcon
        message="Recurring Work Areas"
        description="Recurring work areas will be copied from the master work area. Any customizations on non-master work areas will not be copied."
      />}
      {hasFlatRate && <Alert
        type="warning"
        showIcon
        message="Flat Rate Work Areas"
        description="Flat Rate pricing is no longer available. Work areas with the Flat Rate pricing type will not be copied."
      />}
      <JobTransferTable onSelection={setSelection} />
      <Space direction="horizontal" onClick={() => setCopyNotes(!copyNotes)} style={{ cursor: "pointer" }}>
        <Switch
          checked={copyNotes}
          onChange={x => setCopyNotes(x)}
        />
        Copy Internal Workarea Notes
      </Space>
    </VSpace>}
  </Modal>
}

export default BulkCopyJobModal
